import { Component, Injector, OnInit } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import fr from '@angular/common/locales/fr';
import { ConcilioComponent } from '@conciliome/concilio-core';
import { SharedQuery } from '@b2b-app/b2b-core';

@Component({
  selector: 'b2b-ui-section-garantee',
  templateUrl: './b2b-ui-section-garantee.component.html',
  styleUrls: ['./b2b-ui-section-garantee.component.scss'],
})
export class B2bUiSectionGaranteeComponent extends ConcilioComponent implements OnInit {
  garanties$ = this.sharedQuery.garanties$;

  constructor(injector: Injector, private sharedQuery: SharedQuery) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    registerLocaleData(fr);
  }

  trackByFn(index: number, item: any) {
    return item.id;
  }
}
